import {
  GetPlatformSettingsInput,
  PlatformSettings
} from "../../../../types/gqlTypes/graphql"
import { GET_PLATFORM_SETTINGS } from "./platformSettingsQueries"

import { executeQuerySideload } from "../../../generic-services/helpers/studyPlan"

export async function getPlatformSettings(
  data: GetPlatformSettingsInput
): Promise<PlatformSettings> {
  const response = await executeQuerySideload(GET_PLATFORM_SETTINGS, {
    data
  })

  return response.platformSettings.getPlatformSettings
}
